import { State } from '../models/state';

export class AddressPost {

  constructor() {
    this.id = '';
    this.address1 = '';
    this.address2 = '';
    this.zipCode = '';
    this.city = '';
    this.stateId = '';
    this.latitude = '';
    this.longitude = '';
  }

  //id: string;
  id: string;
  address1: string;
  address2: string;
  zipCode: string;
  city: string;
  stateId: string;
  latitude: string;
  longitude: string;
}



// WEBPACK FOOTER //
// ./src/app/models/address-post.ts